import { ProfileViewResponse } from "@/generated-api";
import IndicatorAndName from "./IndicatorAndName";
import LastSeenBadge from "./LastSeenBadge";

export default function NameAndLastSeen({
  profileView,
}: {
  profileView: ProfileViewResponse;
}) {
  return (
    <div className="w-full flex flex-wrap gap-y-2 items-center justify-between pt-2">
      <IndicatorAndName profileView={profileView} />
      <LastSeenBadge lastActive={profileView.last_active_at} />
    </div>
  );
}
